module.exports = function() {
  return new Worker(__webpack_public_path__ + "2981b1d6a774ccc11e8e.worker.js");
};